export const queryKeys = {
  BROJECT_CONFIG: 'BROJECT_CONFIG'
};
